@let reviewForm = form();
@let shouldShowError = reviewForm.errors?.theftTypeRequired;

<div [formGroup]="reviewForm">
  <app-pan-form-control>
    <app-pan-floating-label>Incident Type</app-pan-floating-label>
    <ul
      class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex"
      [class.border-red-500]="shouldShowError"
      formGroupName="theftType"
    >
      @for (incidentType of incidentTypeRefs(); track $index) {
        <li class="w-full border-gray-200 sm:border-r p-2 flex gap-2">
          <input
            panCheckbox
            [formControlName]="incidentType.formControlName"
            [id]="incidentType.id"
            type="checkbox"
            value=""
            [attr.data-testid]="incidentType.id"
            (change)="onIncidentTypeChange(incidentType.formControlName, $event)"
          />
          <label [for]="incidentType.id">{{ incidentType.label }}</label>
        </li>
      }
    </ul>

    @if (shouldShowError) {
      <div class="text-danger mt-1" role="alert" data-testid="theftTypeError">At least one incident type must be selected.</div>
    }
  </app-pan-form-control>
</div>
